import BossModel from "@/models/BossModel";
import ProductInternalTagType from '@/models/Product/ProductInternalTag/ProductInternalTagType'

export default class ProductInternalTag extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/internal-tag';

    /**
     *
     * @type {string}
     */
    static entity = 'productInternalTags';

    static fields() {
        return {
            id: this.number(null).nullable(),
            name: this.attr(null),
            product_internal_tag_type_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            type: this.belongsTo(ProductInternalTagType, 'product_internal_tag_type_id'),
            // belongsToMany -> products: Product,
        }
    }

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new ProductInternalTag(data[key]));
            }
            return instances;
        });
    }
}
